import { array, object, string } from "yup";

export const templateSchema = object({
    name: string().required(),
    sections: array(),
});
